import { useState, useEffect } from 'react';
import { get } from '@/lib/fetch';

export interface CurrentUser {
  user_id: string;
  email: string;
  name: string;
  permissions: string[];
}

let cachedUser: CurrentUser | null = null;
let cachedPromise: Promise<CurrentUser> | null = null;

export const clearCurrentUserCache = () => {
  cachedUser = null;
  cachedPromise = null;
};

export function useCurrentUser() {
  const [user, setUser] = useState<CurrentUser | null>(cachedUser);
  const [loading, setLoading] = useState(!cachedUser);

  useEffect(() => {
    if (cachedUser) {
      setLoading(false);
      return;
    }

    const fetchCurrentUser = async () => {
      try {
        if (!cachedPromise) {
          cachedPromise = get('/api/users/me');
        }
        const userData = await cachedPromise;
        cachedUser = userData;
        setUser(userData);
      } catch (error) {
        console.error('Error fetching current user:', error);
        cachedPromise = null;
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentUser();
  }, []);

  return { user, loading };
}
